// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-edit-view {
  position: relative;
  flex: 1 1 auto;
  margin: 15px;
}
.image-edit-img2 {
  position: absolute;
  background-color: white;
}
.image-real-size {
  position: absolute;
  overflow: hidden;
}
.water-mark {
  position: absolute;
  z-index: 2;
  /* line-height: 1; */
  min-width: 24px;
  user-select: none;
  /* 适用于大多数浏览器 */
}
.image-edit-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/common/components/ImageEditView/index.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;AACJ;AAEA;EACI,kBAAA;EACA,uBAAA;AAAJ;AAGA;EACI,kBAAA;EACA,gBAAA;AADJ;AAIA;EACI,kBAAA;EACA,UAAA;EAFF,oBAAoB;EAIlB,eAAA;EACA,iBAAA;EAFF,cAAc;AAChB;AAKA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAHJ","sourcesContent":[".image-edit-view {\n    position: relative;\n    flex: 1 1 auto;\n    margin: 15px;\n}\n\n.image-edit-img2 {\n    position: absolute;\n    background-color: white;\n}\n\n.image-real-size {\n    position: absolute;\n    overflow: hidden;\n}\n\n.water-mark {\n    position: absolute;\n    z-index: 2;\n    /* line-height: 1; */\n    min-width: 24px;\n    user-select: none;\n    /* 适用于大多数浏览器 */\n}\n\n.image-edit-canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
